import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  Col,
  FormLabel,
  FormControl,
  FormText,
  Row,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import { BackButton } from "ui/button/back";
import { Notification } from "ui/notification";
import { getErrorMessage } from "util/response";
import { Box } from "view/layout/box";
import { Page } from "view/layout/page";
import zxcvbn from "zxcvbn";

class SettingsPage extends React.PureComponent {
  static get propTypes() {
    return {
      changePassword: PropTypes.func.isRequired,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      p1: "",
      p2: "",
      score: 0,
      showScore: false,
      submitted: false,
      successMessage: "",
      valid: false,
    };

    this._doSubmit = this._doSubmit.bind(this);
    this._passwordChanged = this._passwordChanged.bind(this);
    this._submit = this._submit.bind(this);
  }

  _submit() {
    this.setState({ submitted: true }, this._doSubmit);
  }

  _doSubmit() {
    return this.props
      .changePassword(this.state.p1, this.state.p2)
      .then(() => {
        this.setState({
          errorMessage: "",
          successMessage: "Your password updated successfully.",
        });
      })
      .catch((e) => {
        this.setState({
          errorMessage: getErrorMessage(e),
          successMessage: "",
        });
      })
      .finally(() => {
        this.setState({
          submitted: false,
        });
      });
  }

  _passwordChanged() {
    const p1 = this.password1.value;
    const p2 = this.password2.value;
    const zp1 = zxcvbn(p1);

    let valid = false;
    let showScore = false;
    if (p1) {
      if (p1.length >= 8) {
        valid = p1 === p2;
      }

      if (p1.length > 0) {
        showScore = true;
      }
    }

    let score = 0;
    if (zp1) {
      score = zp1.score;
    }

    this.setState({
      p1,
      p2,
      valid,
      score,
      showScore,
    });
  }

  _renderPasswordScore() {
    if (!this.state.showScore) {
      return null;
    }

    const classes = classNames({
      "progress-bar": true,
      "progress-bar-striped": true,
      "progress-bar-success": this.state.score === 4,
      "progress-bar-warning": this.state.score >= 2 && this.state.score < 4,
      "progress-bar-danger": this.state.score <= 1,
    });
    const style = {
      width: `${this.state.score * 20 + 20}%`,
    };

    return (
      <div className="progress progress-sm active">
        <div
          className={classes}
          style={style}
          aria-value-now="40"
          aria-value-min="0"
          aria-value-max="100"
        ></div>
      </div>
    );
  }

  render() {
    return (
      <Page title="Change Password">
        <Box noHeader>
          <Row>
            <Col sm={6}>
              <Notification
                error={this.state.errorMessage}
                successChildren={<Link to="/overview">Account Overview</Link>}
                success={this.state.successMessage}
              />
              <Row>
                <Col sm={12}>
                  <FormLabel>Password</FormLabel>
                  <FormControl
                    type="password"
                    data-qa="password-field"
                    ref={(c) => {
                      this.password1 = c;
                    }}
                    onChange={this._passwordChanged}
                    required
                  />
                  <FormText>
                    Required. A strong password combines letters, numbers and
                    symbol characters. Your password must be at least 8
                    characters long.
                  </FormText>
                  {this._renderPasswordScore()}
                </Col>
              </Row>
              <Row>
                <Col sm={12}>
                  <FormLabel>Retype Password</FormLabel>
                  <FormControl
                    type="password"
                    data-qa="password-confirm-field"
                    ref={(c) => {
                      this.password2 = c;
                    }}
                    onChange={this._passwordChanged}
                    required
                  />
                </Col>
              </Row>
              <Row className="password-update-row">
                <Col sm={12}>
                  <BackButton />
                  <Button
                    variant="primary"
                    onClick={this._submit}
                    disabled={this.state.submitted || !this.state.valid}
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Box>
      </Page>
    );
  }
}

export { SettingsPage };
